<template>
	<div>
		<!-- <nav-bar /> -->
		<div class="body">
			<svg t="1711362229289" class="close" viewBox="0 0 1024 1024" version="1.1" v-monitor="`返回上一页`" @click.stop="backPage">
				<path
					d="M517.12 944.64c-236.11392 0-427.52-191.40608-427.52-427.52 0-236.11392 191.40608-427.52 427.52-427.52 236.11392 0 427.52 191.40608 427.52 427.52C944.64 753.23392 753.23392 944.64 517.12 944.64zM517.12 143.04256c-206.59712 0-374.08256 167.48544-374.08256 374.08256S310.52288 891.20256 517.12 891.20256c206.60224 0 374.08256-167.48544 374.08256-374.08256S723.72224 143.04256 517.12 143.04256zM555.06432 517.26848l113.2032 113.2032c10.42432 10.42944 10.42432 27.3664 0 37.79584-10.43456 10.42944-27.35104 10.42944-37.79584 0l-113.2032-113.20832-113.99168 113.9712c-10.51648 10.5216-27.5712 10.5216-38.07744 0-10.51648-10.5216-10.51648-27.5712 0-38.07744l113.98144-113.98144L365.97248 403.75296c-10.43456-10.42944-10.43456-27.35104 0-37.78048 10.43456-10.43968 27.34592-10.43968 37.79072 0l113.21344 113.20832 114.82112-114.82112c10.51648-10.5216 27.5712-10.5216 38.08256 0 10.51648 10.51136 10.51648 27.5712 0 38.08256L555.06432 517.26848z"
					fill="#ffffff"
				></path>
			</svg>
			<video ref="player" class="video-js video" playsinline></video>
		</div>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import { Toast } from 'vant';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
export default {
	components: {
		NavBar
	},
	data() {
		return {
			url: '',
			player: null
		};
	},
	mounted() {
		this.closeShare();
		this.$dataStatistics({ event_type: 'view', page_title: '观看视频' }, ``);
		this.url = decodeURIComponent(this.$route.query.video);
		this.initPlayer();
	},
	methods: {
		initPlayer() {
			function fullScreen(ele) {
				if (ele?.requestFullscreen) {
					ele.requestFullscreen();
				} else if (ele?.mozRequestFullScreen) {
					ele.mozRequestFullScreen();
				} else if (ele?.webkitRequestFullscreen) {
					ele.webkitRequestFullscreen();
				} else if (ele?.msRequestFullscreen) {
					ele.msRequestFullscreen();
				}
				return true;
			}

			let vm = this;
			this.player = videojs(this.$refs.player, {
				sources: [
					{
						src: this.url,
						type: 'video/mp4'
					}
				],
				controlBar: {
					minHeight: 80 // 设置控制栏的最小高度为60像素
				},
				muted: false,
				autoplay: true,
				controls: true,
				iOS: false, // 禁用iOS自动全屏
				preload: 'auto'
			});

			this.$nextTick(() => {
				this.player?.play(); // 尝试播放视频
				try {
					// 尝试进入全屏，需要在用户交互下触发
					fullScreen(this.player);
					// 注意：自动全屏可能会因浏览器安全策略而不成功
				} catch (e) {
					console.error('自动进入全屏失败', e);
				}
			});
		}
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
	}
};
</script>
<style lang="less" scoped>
.body {
	// height: calc(100vh - 110px);
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #000;

	.video {
		width: 100vw;
		height: 90%;
		display: block;
	}

	/deep/.video-js,
	.video-js {
		& .vjs-control-bar {
			height: 60px !important;
			display: flex;
			align-items: center;
			& > * {
				height: 100%;
				display: flex;
				align-items: center;
				margin: 0 6px;
				span {
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 26px !important; /* 设置控件按钮字体大小为28像素 */

					&::before {
					}
				}
			}

			.vjs-time-control {
				margin: 0 !important;
			}
		}

		/* 控件按钮样式 */
		& .vjs-control-bar .vjs-icon-placeholder,
		& .vjs-control-bar .vjs-icon-placeholder:before,
		& .vjs-control-bar .vjs-icon-placeholder:after,
		& .vjs-control-bar .vjs-icon-placeholder.vjs-icon-volume-mute:before,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder:before,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder:after {
			font-size: 38px; /* 设置控件按钮字体大小为28像素 */
		}

		& .vjs-volume-panel .vjs-volume-control {
			margin-left: 6px;
			opacity: 1;
		}

		& .vjs-volume-panel-horizontal {
			width: 10em;
		}

		& .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
			width: 5em;
			height: 3em;
			transition: visibility 1s, opacity 1s, height 0s 0s, width 1s, left 0s 0s, top 0s 0s;
		}

		& .vjs-seek-to-live-control {
			display: none !important;
		}

		& .vjs-remaining-time {
			display: none !important;
		}

		& .vjs-picture-in-picture-control {
			display: none !important;
		}

		& .vjs-fullscreen-control {
			min-width: 50px;
			margin-right: 20px;
			span.vjs-icon-placeholder {
				flex: 1;
				position: relative;
				line-height: 1;
				&::before {
					display: block;
					top: 50%;
					transform: translateY(-50%);
					width: auto;
					height: auto;
					line-height: 1;
					font-size: 50px !important;
				}
			}
		}

		& .vjs-progress-control {
		}
	}

	.close {
		position: fixed;
		z-index: 10001;
		right: 20px;
		top: 20px;
		display: block;
		width: 48px;
		height: 48px;
		box-sizing: content-box;
		padding: 10px;
	}
}
</style>
